module.exports = __webpack_public_path__ + "media/logos/press-logo-investors-black-3e14cfe9.svg";